import type { SoundMap } from '@/vue/features/shared/sound/services/sounds/type';
import { Ringtone } from '../types/Ringtone';
import timeExpired from '@/sounds/cue/expired.mp3?url';
import sessionComplete from '@/sounds/cue/complete.mp3?url';
import oneMin from '@/sounds/cue/1min.mp3?url';
import twoMin from '@/sounds/cue/2min.mp3?url';
import threeMin from '@/sounds/cue/3min.mp3?url';
import fiveMin from '@/sounds/cue/5min.mp3?url';
import tenMin from '@/sounds/cue/10min.mp3?url';
import fifteenMin from '@/sounds/cue/15min.mp3?url';
import thirtyMin from '@/sounds/cue/30min.mp3?url';
import oneHour from '@/sounds/cue/1hour.mp3?url';
import alertUp from '@/sounds/cue/alert-up.mp3?url';
import alertDown from '@/sounds/cue/alert-down.mp3?url';
import soarDown from '@/sounds/cue/soar-down.mp3?url';

export const ringtoneMap: SoundMap<Ringtone> = {
    [Ringtone.TIME_EXPIRED]: timeExpired,
    [Ringtone.SESSION_COMPLETE]: sessionComplete,
    [Ringtone.ONE_MINUTE_REMAINING]: oneMin,
    [Ringtone.TWO_MINUTES_REMAINING]: twoMin,
    [Ringtone.THREE_MINUTES_REMAINING]: threeMin,
    [Ringtone.FIVE_MINUTES_REMAINING]: fiveMin,
    [Ringtone.TEN_MINUTES_REMAINING]: tenMin,
    [Ringtone.FIFTEEN_MINUTES_REMAINING]: fifteenMin,
    [Ringtone.THIRTY_MINUTES_REMAINING]: thirtyMin,
    [Ringtone.ONE_HOUR_REMAINING]: oneHour,
    [Ringtone.ALERT_UP]: alertUp,
    [Ringtone.ALERT_DOWN]: alertDown,
    [Ringtone.SOAR_TONE]: soarDown,
};
